import React from "react";
import { Container, Row, Col } from "reactstrap";

const ServicesGrid = ({ data }) => {
    if (!data) return null;

    const { tagline, title, description, services, styles } = data;

    return (
        <section
            className="services"
            id="services"
            style={{
                background: styles?.background || "#fff",
            }}
        >
            <Container>
                {/* Header */}
                <div className="sec-head text-center mb-5">
                    <p className="eyebrow">
                        {tagline}
                    </p>

                    <h2 className="mb-3" style={{ color: styles?.titleColor }}>
                        {title}
                    </h2>

                    <p className="mx-auto" style={{ maxWidth: "700px" }}>
                        {description}
                    </p>
                </div>

                {/* Cards */}
                <Row className="svc-grid g-4">
                    {services.map((service, index) => (
                        <Col md={6} lg={4} key={index}>
                            <div className="service-card h-100">
                                <div className="service-icon">{service.icon}</div>
                                <h5 className="fw-bold mt-3">{service.title}</h5>
                                <p className="">{service.description}</p>
                                <div className="kw-row d-flex flex-wrap gap-2 mt-3">
                                    {service.tags.map((tag, i) => (
                                        <span key={i} className="service-tag">
                                            {tag}
                                        </span>
                                    ))}
                                </div>
                            </div>
                        </Col>
                    ))}
                </Row>
            </Container>
        </section>
    );
};

export default ServicesGrid;